export default __webpack_public_path__ + "static/media/feature_bg3.dd6044fb.png";